
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { FarmPriceFilters } from '@/types/database/farm-prices';

interface FarmPricesFilterProps {
  filters: FarmPriceFilters;
  onFiltersChange: (filters: FarmPriceFilters) => void;
  onClearFilters: () => void;
}

const FarmPricesFilter: React.FC<FarmPricesFilterProps> = ({
  filters,
  onFiltersChange,
  onClearFilters,
}) => {
  const handleFilterChange = (key: keyof FarmPriceFilters, value: string) => {
    onFiltersChange({
      ...filters,
      [key]: value || undefined,
    });
  };

  return (
    <div className="bg-white p-4 rounded-lg border mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <div>
          <Label htmlFor="product_name">Product Name</Label>
          <Input
            id="product_name"
            value={filters.product_name || ''}
            onChange={(e) => handleFilterChange('product_name', e.target.value)}
            placeholder="Search by product..."
          />
        </div>
        <div>
          <Label htmlFor="region">Region</Label>
          <Input
            id="region"
            value={filters.region || ''}
            onChange={(e) => handleFilterChange('region', e.target.value)}
            placeholder="Search by region..."
          />
        </div>
        <div>
          <Label htmlFor="supplier_name">Supplier</Label>
          <Input
            id="supplier_name"
            value={filters.supplier_name || ''}
            onChange={(e) => handleFilterChange('supplier_name', e.target.value)}
            placeholder="Search by supplier..."
          />
        </div>
        <div>
          <Label htmlFor="date_from">Date From</Label>
          <Input
            id="date_from"
            type="date"
            value={filters.date_from || ''}
            onChange={(e) => handleFilterChange('date_from', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="date_to">Date To</Label>
          <Input
            id="date_to"
            type="date"
            value={filters.date_to || ''}
            onChange={(e) => handleFilterChange('date_to', e.target.value)}
          />
        </div>
      </div>
      <div className="flex justify-end mt-4">
        <Button variant="outline" onClick={onClearFilters}>
          Clear Filters
        </Button>
      </div>
    </div>
  );
};

export default FarmPricesFilter;
